// extracted by mini-css-extract-plugin
export default {"wrap":"BottomNav_wrap__ote5C","bar":"BottomNav_bar__Yt9iO","link":"BottomNav_link__K6hoh","active":"BottomNav_active__JXoKf"};